import { Component, Input } from '@angular/core';
import {  Router } from '@angular/router';
import { Location } from '@angular/common';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import Helper from 'src/app/Util/helper';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { ExternalLinks } from 'src/app/interfaces/environment.interface';
import { PackageNames } from 'src/app/enums/package-names';
import { Edition } from 'src/app/enums/plan.enum';


@Component({
  selector: 'app-remote-client',
  templateUrl: './guide.component.html',
  styleUrl: './guide.component.sass',
})
export class  GuideComponent {
  private unsubscribe$ = new Subject<void>()
  environmentInfo : any;
  supportEmail = 'support@alachisoft.com'
  subscriptionId: any;
  configCode : any;
  dotNetCode  : any;
  javaCode  : any;
  activeTab: string = 'dotnet';
  powershell: string =''
  defaultIp : string = '200.200.200.200'
  planEdition : string = ''
  links : ExternalLinks 
  isApiInProgress:boolean = false
  @Input() linkType: string = '';

    constructor(
      private route: Router,
      private location: Location,
      private environmentService: EnvironmentService,
      private notificationService: CloudNotificationService
    )
    {
      const navigation = this.route.getCurrentNavigation();
      this.environmentInfo = navigation?.extras?.state?.['environment'];
      this.linkType = navigation?.extras?.state?.['linkType'];
      this.planEdition = navigation?.extras?.state?.['planEdition']
    }


    ngOnInit(): void
    {
      this.getFirstPublicIp()
      this.getExternalLinks()
this.configCode =
`
<configuration>
  <ncache-server connection-retries="3" retry-connection-delay="0" retry-interval="1" command-retries="3" command-retry-interval="0.1" client-request-timeout="90" connection-timeout="5" port="9800" local-server-ip="${this.getFirstPrivateIp() ?? this.defaultIp}" enable-keep-alive="False" keep-alive-interval="30"/>
  <cache id="demoCache" client-cache-id="" client-cache-syncmode="optimistic" default-readthru-provider="" default-writethru-provider="" skip-client-cache-if-unavailable="true" reconnect-client-cache-interval="10" load-balance="false" enable-client-logs="False" log-level="error">
    ${this.getServerXmlEntries()}"/>
  </cache>
</configuration>
  `;

this.dotNetCode =
`
CacheConnectionOptions cacheConnectionOptions = new CacheConnectionOptions();
String serverIp = "${this.getFirstPublicIp() ?? this.defaultIp}";
cacheConnectionOptions.ServerList = new List<ServerInfo>()
{
    new ServerInfo(serverIp)
};
ICache cache = CacheManager.GetCache("demoCache", cacheConnectionOptions);`;

this.javaCode =
`
CacheConnectionOptions cacheConnectionOptions = new CacheConnectionOptions();
String serverIp = "${this.getFirstPublicIp() ?? this.defaultIp}";

List<ServerInfo> serverList = new ArrayList();
serverList.add(new ServerInfo(serverIp));

cacheConnectionOptions.setServerList(serverList);
Cache cache = CacheManager.getCache("demoCache", cacheConnectionOptions);`;

  }

  back()
  {
    this.location.back()
  }

  getFirstPublicIp()
  {
    if(this.environmentInfo?.servers.length > 0)
    {
      return this.environmentInfo?.servers[0].publicIp  === null  ||  this.environmentInfo?.servers[0].publicIp === undefined  ? this.environmentInfo?.servers[0].privateIp : this.environmentInfo?.servers[0].publicIp
    }

    return this.defaultIp
  }

  getIpAndPort():string{
   return this.getFirstPublicIp()+':8251'
  }

  getServerXmlEntries(): string[] {
    if (this.environmentInfo?.servers.length > 0) {
      return this.environmentInfo?.servers.map(server => {
        const publicIp = server.publicIp || server.privateIp;
        return publicIp;
      }) || [];
    }
    return [this.defaultIp];
  }




  getFirstPrivateIp()
  {
    if(this.environmentInfo?.servers.length > 0)
    {
      return this.environmentInfo?.servers[0].privateIp
    }

    return this.defaultIp
  }

  getlistofIps(): string {

    if(this.environmentInfo?.servers.length > 0){

      return this.environmentInfo?.servers
      ?.map(server => server.privateIp)
      .join(', ') || '';
    }
    return this.defaultIp
  }


  copyCode(id: string) {
    const codeBlock = document.getElementById(id + '-code');
    if (codeBlock) {
      const textToCopy = codeBlock.innerText;
      navigator.clipboard.writeText(textToCopy).then(() => {
      }).catch(err => {
      });
    }
  }

  ifPublicIpEnabled():boolean{
    return this.environmentInfo?.assignPublicIp
  }


  private getExternalLinks(): void {
    this.isApiInProgress = true
    this.environmentService.getExternalLinks().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (links) => {
        this.links = links
        this.isApiInProgress = false
      },
      error: (err: HttpErrorResponse) => {
        this.isApiInProgress = false
        this.notificationService.createToastNotification('get-external-links', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }
    });
  }

  getPackageLink(packageName:string):string{
    switch(packageName){
      case PackageNames.Nuget:
        return this.planEdition == Edition.Enterprise ? this.links.link_nuget_pacakage_enterprise : this.links.link_nuget_pacakage_profressional
      case PackageNames.Maven:
        return this.planEdition == Edition.Enterprise ? this.links.link_maven_pacakage_enterprise : this.links.link_maven_pacakage_profressional
      case PackageNames.Npm:
        return this.planEdition == Edition.Enterprise ? this.links.link_npm_pacakage_enterprise : this.links.link_npm_pacakage_profressional
      case PackageNames.Pipy:
        return this.planEdition == Edition.Enterprise ? this.links.link_pipy_pacakage_enterprise : this.links.link_pipy_pacakage_profressional
      default:
        return this.links.link_installer
    }
  }
}
